export default {
  zones: 'ansp/zones',
  zonesCategories: 'zones/category',
  anspZonesFilters: 'ansp/zones/filter',
  operations: 'operations',
  missions: 'missions',
  missionsLength: 'missions/length',
  missionsFilters: 'missions/filters',
  missionsFiltersLength: 'missions/filters/length',
  missionsHistory: 'missions/history',
  organizations: 'organizations',
  operationsFilters: 'operations/filters',
  operationsFiltersLength: 'operations/filters/length',
  organization: 'organization',
  generatePolygonFromCircle: 'calcbuffer',
  addUser: 'register',
  editUser: 'user',
  editUserByAdmin: 'editUserInOrganization',
  userList: 'users',
  login: 'login',
  permissions: 'permissions',
  permissionsList: 'permissions/groups',
  areas: 'zones',
  receivers: 'receivers',
  resetPassword: 'passwordResetEmail',
  setNewPassword: 'passwordReset',
  uavoHistory: 'aircrafts/positions',
  droneHistory: 'drones/positions',
  radarHistory: 'radar/positions',
  setUserConfiguration: 'user',
  refreshToken: 'token/refresh',
  mappingTable: 'mapping_table',
  missionsApprovals: 'missions/approvals/all',
  missionApproval: 'missions/approval',
  operationApproval: 'operations/statuses',
  operationsApprovals: 'operations/statuses/all',
  missionsApprovalsHistory: 'missions/approvals/history/statuses',
  weather: 'weather',
  operationsHistory: 'operations/statuses/history',
  systemSettings: 'system_settings',
  privateZones: 'zones/private',
  privateZonesLength: 'zones/private/length',
  activations: 'activations',
  drones: 'drones',
  identifications: 'identifications',
  identificationsSingle: 'identifications/info',
  subscriptions: 'subscriptions',
  subscriptionPlans: 'subscription_plans',
  corridorsReport: 'zones/corridors/report',
};
